<template>
  <div v-if="result" class="def-labels">
    <span
      v-for="item in result"
      class="def-labels__item"
      :style="`background-color: ${item.color}`"
    >
      {{ item.name }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'DefLabels',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.def-labels {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  &__item {
    padding: 5px 4px 1px;
    //font-weight: 600;
    font-size: rem(12);
    line-height: 100%;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    white-space: nowrap;
    margin-bottom: 8px;
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
}
</style>
